import React from 'react';
import classNames from 'classnames';
import styles from './UpgradePromptPill.less';
import { Icon, IconName } from 'app/common/components/controls';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import RouterLink from 'app/common/components/singlespa/router-link';
import { dontUpsell } from '@trello/config';

/**
 * UpgradePromptPillProps props
 * isDarkTheme: For dark theme
 * cta: call to action of prompt, navigates user within the page
 * ctaLink: link for call to action
 * ctaOnClick: function expected to fire side-effects like a trackUe event,
 *             fired on click of cta
 */
interface UpgradePromptPillProps {
  isDarkTheme?: boolean;
  allowUpsell?: boolean;
  cta: string;
  ctaLink?: string;
  ctaOnClick?: () => void;
  iconName: IconName;
}

export const UpgradePromptPill: React.FunctionComponent<UpgradePromptPillProps> = ({
  isDarkTheme,
  cta,
  ctaLink,
  ctaOnClick,
  iconName,
  allowUpsell,
}) => {
  if (dontUpsell && !allowUpsell) {
    return null;
  }

  const onClickCTA = () => {
    if (ctaOnClick) {
      ctaOnClick();
    }
  };

  const upgradePromptPillClasses = classNames(
    styles.upgradePromptPill,
    isDarkTheme ? styles.upgradeDarkTheme : styles.upgradeLightTheme,
  );

  const LinkComponent = ctaLink === '/business-class' ? 'a' : RouterLink;

  const pillContent = (
    <>
      <Icon name={iconName} className={styles.upgradePromptPillIcon} small />
      <div className={styles.upgradePromptPillCTA}>{cta}</div>
    </>
  );

  if (!ctaLink) {
    return (
      <button className={upgradePromptPillClasses} onClick={onClickCTA}>
        {pillContent}
      </button>
    );
  }

  return (
    <LinkComponent
      href={ctaLink}
      className={upgradePromptPillClasses}
      onClick={onClickCTA}
    >
      {pillContent}
    </LinkComponent>
  );
};

export const UpgradePromptPillConnected: React.FunctionComponent<UpgradePromptPillProps> = (
  props,
) => (
  <ComponentWrapper>
    <UpgradePromptPill {...props} />
  </ComponentWrapper>
);
